import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  initialized = false;
  domain = '';
  subdomain = '';
  isInternal = false;
  isMunicipal = false;

  shouldRedirectToAdmin = false;
  targetAdminUrl = '';

  init() {
    const fullHost = window.location.host;
    const host = window.location.hostname;
    const currentPath = window.location.pathname;
    const parts = host.split('.');
    const first = parts[0].toLowerCase();
    this.initialized = true;

    if (first === 'admin') {
      this.isInternal = true;
      this.domain = 'admin';
      this.subdomain = 'transparenciaeducacao';

      if (!currentPath.startsWith('/adm') && !currentPath.startsWith('/authentication')) {
        this.shouldRedirectToAdmin = true;
        this.targetAdminUrl = `https://${fullHost}$/adm`;
      }

      return;
    }

    if (environment.name === 'development') {
      this.domain = 'localhost';
      this.subdomain = 'localhost';

      if (currentPath.startsWith('/adm')) {
        this.isInternal = true;
      } else {
        this.isInternal = false;
        this.isMunicipal = true;
      }
      return;
    }

    if (environment.name === 'producao') {
      this.isMunicipal = true;
      this.domain = first;
      this.subdomain = parts[1].toLowerCase();

      if (currentPath.startsWith('/adm')) {
        this.shouldRedirectToAdmin = true;
        this.targetAdminUrl =
          `https://admin.transparencia.educacao.imap.org.br${currentPath}`;
      }

      return;
    }

    if (environment.name === 'homologacao' || environment.name === 'staging') {
      this.isMunicipal = true;
      this.domain = environment.name;
      this.subdomain = environment.name;

      if (currentPath.startsWith('/adm')) {
        this.shouldRedirectToAdmin = true;
        this.targetAdminUrl =
          `https://admin.transparencia.educacao.${environment.name}.imap.org.br${currentPath}`;
      }

      return;
    }
  }

  getAdminUrl(path: string = '/adm'): string {
    const p = path.startsWith('/') ? path : `/${path}`;

    if (environment.name === 'development') {
      return `${window.location.origin}${p}`;
    }

    if (environment.name === 'producao') {
      return `https://admin.transparencia.educacao.imap.org.br${p}`;
    }

    const env = environment.name;
    return `https://admin.transparencia.educacao.${env}.imap.org.br${p}`;
  }
}
